import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useId, useState } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Fade from "@mui/material/Fade";
import Stack from "@mui/material/Stack";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DynamicContainer from "@project/templates/home/DynamicContainer";
import IllustrationTabButton from "./IllustrationTabButton";
const IllustrationTabPanel = (props) => {
    const { id, orientation = "vertical", dynamicList = [] } = props;
    const [value, setValue] = useState(0);
    const uid = useId();
    const isVertical = orientation === "vertical";
    const theme = useTheme();
    const isMobile = !useMediaQuery(theme.breakpoints.up("md"));
    // Les onglets repassent en ligne scrollable sur mobile, quelle que soit l'orientation
    const isTablistVertical = isVertical && !isMobile;
    const handleChange = (_event, newValue) => {
        setValue(newValue);
    };
    const renderPanelContent = (tab) => {
        const blocks = React.Children.toArray(tab.dynamicPart);
        return (_jsxs(Stack, { direction: { xs: "column", md: "row" }, spacing: { xs: 2, md: 3 }, sx: { width: "100%", alignItems: "stretch" }, children: [_jsxs(DynamicContainer, { spacing: 3.5, sx: {
                        flex: 1,
                        minWidth: 0,
                        backgroundColor: "background.default",
                        p: { xs: 3, md: 5 },
                    }, children: [(tab.label || tab.description) && (_jsxs(Stack, { spacing: 1, children: [tab.label && (_jsx(Typography, { variant: "h5", component: "h3", children: tab.label })), tab.description && (_jsx(Typography, { variant: "body1", children: tab.description }))] })), blocks.map((block, index) => (_jsxs(Fragment, { children: [index > 0 && (_jsx(Divider, { sx: { backgroundColor: "border.default" } })), block] }, index)))] }), _jsx(Stack, { sx: {
                        flexShrink: 0,
                        alignSelf: "stretch",
                        display: { xs: "none", md: "flex" },
                        width: { xs: "100%", md: isVertical ? 280 : 450 },
                        minHeight: isVertical ? 280 : 450,
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundImage: isVertical
                            ? "url('/fond-illus.svg')"
                            : "url('/fond-illus-large.svg')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }, children: tab.illustration?.url && (_jsx(Box, { component: "img", src: tab.illustration.url, alt: tab.illustration.alt || "", sx: {
                            width: isVertical ? 240 : 260,
                            height: isVertical ? 240 : 260,
                            objectFit: "contain",
                        } })) })] }));
    };
    return (_jsx(Stack, { spacing: { xs: 2, md: 3 }, sx: { width: "100%" }, children: _jsxs(Stack, { direction: { xs: "column", md: isVertical ? "row" : "column" }, spacing: { xs: 2, md: 3 }, sx: { width: "100%", alignItems: "stretch" }, children: [_jsx(Tabs, { value: value, onChange: handleChange, orientation: isTablistVertical ? "vertical" : "horizontal", variant: !isMobile && !isVertical ? "fullWidth" : "scrollable", scrollButtons: false, sx: {
                        flexShrink: 0,
                        ...(isVertical && { width: { xs: "100%", md: 300 } }),
                        "& .MuiTabs-indicator": { display: "none" },
                        "& .MuiTabs-flexContainer": { gap: "12px" },
                    }, children: dynamicList.map((tab, index) => (_jsx(IllustrationTabButton, { tab: tab, index: index, selectedIndex: value, uid: uid, isTablistVertical: isTablistVertical }, tab.id || `${tab.label}-${index}`))) }), _jsx(Box, { sx: { flex: 1 }, "aria-live": "polite", children: dynamicList.map((tab, index) => (_jsx(Fade, { in: value === index, timeout: 800, children: _jsx(Box, { role: "tabpanel", tabIndex: 0, hidden: value !== index, id: `${uid}-tabpanel-${index}`, "aria-labelledby": `${uid}-tab-${index}`, sx: { width: "100%" }, children: value === index && renderPanelContent(tab) }) }, tab.id || `${tab.label}-${index}`))) })] }) }, id));
};
export default IllustrationTabPanel;
